<template>
  <b-tabs expanded>
    <b-tab-item label="Perfil">
      <form id="FormularioCrud" class="columns is-multiline" @submit.prevent="sendForm">
        <b-field class="column is-6" label="Socio *" label-position="horizontal">
          <b-input v-model="form.socio" type="text" required></b-input>
        </b-field>

        <b-field class="column is-6" label="Nombre *" label-position="horizontal">
          <b-input v-model="form.nombre" type="text" required></b-input>
        </b-field>

        <b-field class="column is-6" label="Apellido" label-position="horizontal">
          <b-input v-model="form.apellido" type="text"></b-input>
        </b-field>

        <b-field class="column is-6" label="Teléfono" label-position="horizontal">
          <b-input v-model="form.telefono" type="text"></b-input>
        </b-field>

        <b-field
          class="column is-12"
          label="Contraseña"
          message="Debe tener al menos 8 caracteres, incluir 1 mayúscula, 1 minúscula y 1 número."
          label-position="horizontal"
        >
          <b-input v-model="form.password" type="password" password-reveal></b-input>
        </b-field>

        <b-field class="column is-6" label="Email *" label-position="horizontal">
          <b-input v-model="form.email" type="email" required></b-input>
        </b-field>

        <b-field class="column is-6" label="RFC *" label-position="horizontal">
          <b-input v-model="form.rfc" type="text" required></b-input>
        </b-field>

        <b-field class="column is-6" label="Nombre comercial" label-position="horizontal">
          <b-input v-model="form.nombre_comercial" type="text" disabled></b-input>
        </b-field>

        <b-field class="column is-6" label="Empresa" label-position="horizontal">
          <b-input v-model="form.empresa" type="text" disabled></b-input>
        </b-field>

        <b-field class="column is-6" label="Paquete" label-position="horizontal">
          <b-input v-model="form.paquete" type="text" disabled></b-input>
        </b-field>

        <b-field class="column is-6" label="Vigencia" label-position="horizontal">
          <b-input v-model="form.vigencia" type="date" disabled></b-input>
        </b-field>

        <b-field class="column is-6" label="Jefe de sección" label-position="horizontal">
          <b-switch v-model="form.jefe_seccion" disabled></b-switch>
        </b-field>

        <b-field class="column is-6" label="Jefe de círculo" label-position="horizontal">
          <b-switch v-model="form.jefe_circulo" disabled></b-switch>
        </b-field>

        <b-button class="is-success" type="submit" native-type="submit" label="Guardar" expanded></b-button>
      </form>
    </b-tab-item>

    <b-tab-item label="Reuniones" :disabled="!form.id">
      <div class="mb-4">
        <b-notification v-if="meetingsSummary" :type="meetingsSummary.blocked ? 'is-danger' : 'is-info'" :closable="false">
          Faltas no justificadas: <strong>{{ meetingsSummary.unjustified_absences }}</strong> / {{ meetingsSummary.threshold }}
        </b-notification>
      </div>

      <b-table :data="meetings" :striped="true" :hoverable="true" :loading="loadingMeetings">
        <b-table-column field="fecha_reunion" label="Fecha" width="160" v-slot="props">
          {{ (props.row.fecha_reunion || '').substr(0, 10) }}
        </b-table-column>
        <b-table-column field="titulo" label="Reunión" v-slot="props">
          <div class="has-text-weight-semibold">{{ props.row.titulo }}</div>
          <div class="has-text-grey is-size-7">{{ props.row.lugar }}</div>
        </b-table-column>
        <b-table-column field="estatus" label="Asistencia" width="200" v-slot="props">
          <div class="is-flex is-align-items-center" style="gap: 0.75rem">
            <b-select v-model="props.row.estado_asistencia" size="is-small">
              <option value="pendiente">Pendiente</option>
              <option value="confirmado">Asistió</option>
              <option value="rechazado">Faltó</option>
            </b-select>
            <b-checkbox
              v-if="props.row.estado_asistencia === 'rechazado'"
              v-model="props.row.falta_justificada"
              size="is-small"
            >
              Justificada
            </b-checkbox>
          </div>
        </b-table-column>
        <b-table-column label="" width="140" v-slot="props">
          <b-button size="is-small" type="is-primary" :loading="savingIds[props.row.participante_id]" @click="saveAttendance(props.row)">
            Guardar
          </b-button>
        </b-table-column>
      </b-table>
    </b-tab-item>
  </b-tabs>
</template>

<script>
import { mapActions } from 'vuex';
import Swal from 'sweetalert2';
import axiosInstance from '@/api/axiosInstance';

export default {
  props: {
    datavalues: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      form: {},
      meetings: [],
      meetingsSummary: null,
      loadingMeetings: false,
      savingIds: {},
      initialFormState: {
        id: null,
        nombre: '',
        apellido: '',
        empresa: '',
        nombre_comercial: '',
        telefono: '',
        email: '',
        password: '',
        socio: '',
        jefe_seccion: false,
        jefe_circulo: false,
        rfc: '',
        paquete: '',
        vigencia: '',
      },
    };
  },
  watch: {
    datavalues: {
      immediate: true,
      handler(newData) {
        this.loadFormData(newData);
        if (newData?.id) {
          this.loadMeetings(newData.id);
        } else {
          this.meetings = [];
          this.meetingsSummary = null;
        }
      },
    },
  },
  methods: {
    ...mapActions({
      submitForm: 'associates/submitForm', // Asegúrate de tener esta acción en Vuex
      fetchMeetings: 'associates/fetchMeetings',
    }),
    async loadFormData() {
      if (this.datavalues && Object.keys(this.datavalues).length) {
        Object.keys(this.initialFormState).forEach((key) => {
          this.form[key] = this.datavalues[key] ?? this.initialFormState[key];
        });

        this.form.password = this.initialFormState.password;
        this.form.jefe_seccion = this.datavalues.jefe_seccion == '1' || this.initialFormState.jefe_seccion;
        this.form.jefe_circulo = this.datavalues.jefe_circulo == '1' || this.initialFormState.jefe_circulo;
      } else {
        this.form = { ...this.initialFormState };
      }
    },
    async sendForm() {
      const payload = {
        ...this.form,
        jefe_seccion: this.form.jefe_seccion ? 1 : 0,
        jefe_circulo: this.form.jefe_circulo ? 1 : 0,
      };

      if (this.form.password !== '' && !this.isPasswordValid(this.form.password)) {
        Swal.fire({
          icon: 'error',
          title: 'La contraseña debe contener al menos una letra mayúscula, una letra minúscula y un número.',
          confirmButtonColor: '#268af7',
        });
        this.isLoading = false;
        return;
      }

      const response = await this.submitForm(payload);

      Swal.fire({
        icon: response.status ? 'info' : 'error',
        title: response.message,
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: true,
      });

      if (response.status) {
        this.$store.commit('associates/SET_DATA', { key: 'reloadList', data: true });
        this.closeForm();
      }
    },
    async loadMeetings(socioId) {
      this.loadingMeetings = true;
      try {
        const payload = await this.fetchMeetings(socioId);
        this.meetings = (payload?.list || []).map((r) => ({
          ...r,
          falta_justificada: r.falta_justificada === 1 || r.falta_justificada === '1' || r.falta_justificada === true,
        }));
        this.meetingsSummary = payload?.summary || null;
      } catch (e) {
        this.meetings = [];
        this.meetingsSummary = null;
      } finally {
        this.loadingMeetings = false;
      }
    },
    async saveAttendance(row) {
      const id = row.participante_id;
      this.$set(this.savingIds, id, true);
      try {
        const payload = {
          id,
          estado_asistencia: row.estado_asistencia,
          falta_justificada: row.estado_asistencia === 'rechazado' && row.falta_justificada ? 1 : 0,
        };
        const response = await axiosInstance.post('/meetings/participants_save', payload);
        const ok = response?.data?.status;
        this.$buefy.toast.open({
          message: ok ? 'Guardado' : (response?.data?.message || 'No se pudo guardar'),
          type: ok ? 'is-success' : 'is-danger',
        });
      } finally {
        this.$set(this.savingIds, id, false);
      }
    },
    closeForm() {
      this.$emit('close-form');
    },
    isPasswordValid(password) {
      // Expresión regular para al menos una mayúscula, una minúscula y un número
      const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).+$/;
      return regex.test(password);
    },
  },
};
</script>

<style scoped>
.form-horizontal {
  max-width: 600px;
  margin: auto;
}
</style>
